/** @format */
import process from "process";
import { apiRequest } from "../Component/Utils/ApiHundler";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function getDoc(token, instanceId) {
  const apiUrl = `${API_BASE_URL}/document/list`;

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      InstanceId: instanceId,
    }),
  });

  return data.message.list;
}